import { odata } from '../../conf';
import Actions from '../../odata/actions';

const actions = new Actions('budgetWatchList', 'budgetWatchLists');

const customActions = {
  async DELETE_budgetWatchList({ commit, rootGetters, state }, data) {
    const budgetWatchList = state.budgetWatchLists
      .find((b) => b.categoryCodeId === data.categoryCodeId);
    const i = odata.parseId(budgetWatchList.id);
    await await odata.o(rootGetters)
      .delete(`budgetWatchLists(${i})`, data)
      .query();
    const items = state.budgetWatchLists.filter((item) => item.id !== i);
    commit('SET_budgetWatchLists', items);
  },
};

export default { ...actions, ...customActions };
